import createDocumentResource from 'src/actions/shared/createDocumentResource';
import { IsInt, Min, Max, Validate, ValidateNested } from 'class-validator';
import { IsValidAgentMaxCapacity } from 'src/actions/messaging/validators/isValidAgentMaxCapacity';
import { Type } from 'class-transformer';

class MessageConfig {
  @IsInt()
  @Min(1, { message: 'Enter a value greater than or equal to 1' })
  agentCapacity: number;

  @IsInt()
  @Validate(IsValidAgentMaxCapacity)
  agentMaxCapacity: number;

  assignMailToConversationAssignee: boolean;
  autoAssignMessagingSessions: boolean;

  @IsInt()
  @Min(10, { message: 'Please pick a value between 10 and 300 seconds' })
  @Max(300, { message: 'Please pick a value between 10 and 300 seconds' })
  chatSessionRejoinWindowSecs: number;

  closeAbandonedChatSessions: boolean;

  enableFocusMode: boolean;

  @IsInt()
  @Min(0, { message: 'Enter a value greater than or equal to 0' })
  endMailSessionIntervalMins: number;

  @IsInt()
  @Min(1, { message: 'Enter a value greater than or equal to 1' })
  endMessagingSessionIntervalMins: number;

  @ValidateNested()
  @Type(() => LookupBeforeRoutingConfig)
  lookupBeforeRouting: LookupBeforeRoutingConfig;

  routeNextMessagingSessionIntervalSecs: number;
  showPreview: boolean;
  enableOutboundInstagramMessageEcho: boolean;
  handleInstagramStoryMentions: boolean;
  handleInstagramComments: boolean;
}

class LookupBeforeRoutingConfig {
  enabled: boolean;

  @IsInt()
  @Max(15, { message: 'Please pick a timeout value between 1 and 15 seconds' })
  @Min(1, { message: 'Please pick a timeout value between 1 and 15 seconds' })
  timeoutSecs: number;
}

export default createDocumentResource<MessageConfig>({
  name: 'messaging',
  endpoint: 'v1/orgs/:orgId/configuration/messaging',
  type: MessageConfig,
});
